import React from 'react';
import {t} from '@lingui/core/macro';
import {toast} from 'react-toastify';

import Button from 'shared/ui/Button/Button/Button';

import Box from '../../../../../shared/ui/Box/Box';


import styles from './HttpMonitorUnsubscribe.module.scss';


interface IHttpMonitorUnsubscribeProps {
    unsubscribeHandler: () => Promise<{success: boolean}>,
    domain: string,
}

const HttpMonitorUnsubscribe: React.FC<IHttpMonitorUnsubscribeProps> = ({unsubscribeHandler, domain}) => {

    const unsubscribe = async() => {
        const result = await unsubscribeHandler();
        if (result.success) {
            toast.info(t`Вы успешно отписались от мониторинга Вашего сайта`);
        } else {
            toast.error(t`Произошла ошибка при отписке от мониторинга Вашего сайта`);
        }
    };
    return (
        <div className={styles.wrapper}>
            <div className={styles.box_wrapper}>
                <Box>
                    <div className="row text-center mb-3">
                        <div className="col-12">
                            <p className={styles.text}>
                                {/* eslint-disable-next-line max-len */}
                                {t`Вы действительно хотите запретить сервису`} <strong>Overseer</strong> {t`мониторить все адреса, принадлежащие доменному имени`} <strong>{domain}</strong>?
                            </p>
                            <p className={styles.text}>
                                {/* eslint-disable-next-line max-len */}
                                {t`Отменить запрет можно будет только через обращение в техническую поддержку, подтвердив что вы - владелец доменного имени`}
                            </p>

                            <Button
                                onClick={unsubscribe}
                            >
                                {t`Отписаться от мониторинга сайта`}
                            </Button>
                        </div>
                    </div>
                </Box>
            </div>
        </div>
    );
};

export default HttpMonitorUnsubscribe;